import React, { Component, Fragment } from 'react'
import { Link } from "react-router-dom";
import { Container,Row,Col, Form,Button } from 'react-bootstrap'
import Product1 from '../../assets/images/product/servivesproducts.png'
import { Helmet } from "react-helmet";
import { FaArrowRight } from "react-icons/fa";

class About_us extends Component {
     render() {
          return (
               <Fragment>
     <Helmet>
                                        <title>
                                             About Us | Chrisalpha Tech Company Ltd
                                        </title>
                    
                                        <meta
                                             name="description"
                                             content="Learn about Chrisalpha Tech Company Ltd, a software development company in Uganda providing POS systems, websites, mobile apps and IT solutions."
                                        />
                    
                                        <meta
                                             name="keywords"
                                             content="About Chrisalpha Tech, software company Uganda, IT company Kampala, POS systems Uganda"
                                        />
                </Helmet>
              <Container fluid={true}  className="BetweenTwoSection">
                   <Row className="">
<Col className="shadow-sm bg-white pb-3 mt-4" md={12} lg={12} sm={12} xs={12}>
     <Row>
          <Col className="p-3" md={6} lg={6} sm={12} xs={12}>
          <img className="w-100" src={Product1} />
          <Container  className="my-3">
               
         




          </Container>
          </Col>
          <Col className="p-3 " md={6} lg={6} sm={12} xs={12}>
            <h4>Chrisalpha Tech Company Ltd</h4>
          
             <p>


CHRISALPHA TECH COMPANY LTD is a professional software development and information technology company dedicated to
 delivering high-quality digital solutions. The company specializes in the design, development, and implementation of 
 reliable and scalable software systems tailored for businesses, organizations, and institutions.




</p>

<p>

We are committed to providing innovative, efficient, and user-friendly technology and enterprise 
solutions that enable our clients to improve productivity, streamline operations, and enhance overall customer experience. 
Through a combination of technical expertise and a deep understanding of business needs, we strive to deliver solutions
 that drive growth and long-term success.

</p>
          <div className="">
           <h6> We focus on building customized systems such as:</h6>
             <ul className="login-steps">
            <li>Point of Sale (POS) systems for retail and business management</li>
            <li>ParkEase, a smart parking management solution</li>
            <li>Trade Hub, a platform designed to support trading and business operations</li>
            <li>Other web-based and enterprise applications tailored to client needs</li>
            </ul>
          <p>At Chrisalpha Tech, we are committed to delivering reliable,
scalable, and user-friendly technology solutions. Our goal is to empower businesses with tools that improve efficiency, enhance customer experience, and increase profitability.
We combine innovation, technical expertise, and a deep
 understanding of business needs to create solutions that make a real impact.</p>

          </div>
 <div className="column-center">
  <Link to="/about" className="read-more">
    Read More <FaArrowRight className="blue-arrow" />
  </Link>
</div>
        
          </Col>
     </Row>

</Col>
                   </Row>
               </Container>
               
               </Fragment>
          )
     }
}

export default About_us